export default __webpack_public_path__ + "static/media/pflastern-1.3961252e.jpeg";